import {getToken} from '@/services/auth/index'
import {TOKEN, REFRESH_TOKEN, TOKEN_EXPIRES, CLIENT_ID} from '@/shared/constants.js'
import {enableUser} from "@/services/user";

const state = {
  token: localStorage.getItem(TOKEN),
}

const mutations = {
  setToken(state, token) {
    state.token = token
  },
}

const actions = {
  actionSetLogoutTimer({commit}, expirationTime) {
    setTimeout(() => {
      commit('setToken', null)
    }, expirationTime)
  },
  actionLogin: ({commit}, authData) => {
    return new Promise((resolve, reject) => {
      getToken(authData).then(response => {
        const now = new Date()
        const expirationDate = new Date(now.getTime() + response.expires_in)
        localStorage.setItem(TOKEN, response.access_token)
        localStorage.setItem(REFRESH_TOKEN, response.refresh_token)
        localStorage.setItem(TOKEN_EXPIRES, expirationDate)
        commit('setToken', response.access_token)

        return resolve(response);
      }).catch((error) => {
        return reject(error);
      })
    })
  },
  actionLogout({commit}) {
    commit('setToken', null)
    commit('client/setClient', {}, { root: true })
    commit('user/setUserItem', {path: 'permissions', value: []}, { root: true })
    commit('user/setUser', {}, { root: true })
    localStorage.clear();
  },
  actionAutoLogin({commit}) {
    const token = localStorage.getItem(TOKEN)
    if (token) {
      commit('setToken', token)
      return true
    }
    if (!getters.getAuthStatus) {
      return false
    }
    return true
  },

  actionEnableUser({commit},payload){
    return new Promise((resolve, reject) => {
      enableUser(payload.id, payload).then(response => {
        const now = new Date()
        const expirationDate = new Date(now.getTime() + response.expires_in)
        localStorage.setItem(TOKEN, response.access_token)
        localStorage.setItem(REFRESH_TOKEN, response.refresh_token)
        localStorage.setItem(TOKEN_EXPIRES, expirationDate)
        commit('setToken', response.access_token)
        resolve(response);
      }, error => {
        reject(error);
      })
    })
  },
  }

const getters = {
  getAuthStatus: function () {
    return state.token !== null
  },
  getToken: function () {
    return state.token
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
